import React from 'react';
import { PsPage } from '../../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { WorkDetailCard } from './WorkDetailCard';
import { BreadcrumbsManagerInstance } from '../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../shared/breadcrumbs/Breadcrumbs';

export class WorkDetailScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_CONTRACTORS,
            Breadcrumbs.MY_CONTRACTORS_WORKS,
            Breadcrumbs.MY_CONTRACTORS_WORKS_DETAIL,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_OBRA_DE_MI_CONTRATISTA')} breadcrumbs={breadcrumbs}>
                <WorkDetailCard
                    id={this.props.match.params.id}
                    appendBreadcrumb={this.appendBreadcrumb}
                />
            </PsPage>
        );
    }

    appendBreadcrumb = (work) => {
        BreadcrumbsManagerInstance.finishLoading({
            id: Breadcrumbs.MY_CONTRACTORS_WORKS_DETAIL.id,
            url: this.props.location.pathname,
            description: work.description(),
        });

        this.setState({
            breadcrumbs: [...BreadcrumbsManagerInstance.breadcrumbs()],
        });
    };

}



// WEBPACK FOOTER //
// ./src/app/my-contractors/work/detail/WorkDetailScreen.jsx